export default __webpack_public_path__ + "static/media/bg-image-6.eeb82ebe.jpg";